import { render, staticRenderFns } from "./endorse.vue?vue&type=template&id=51fbacae&scoped=true&"
import script from "./endorse.vue?vue&type=script&lang=js&"
export * from "./endorse.vue?vue&type=script&lang=js&"
import style0 from "./endorse.vue?vue&type=style&index=0&id=51fbacae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fbacae",
  null
  
)

export default component.exports